module.exports = require("./xlsx.js");


//////////////////
// WEBPACK FOOTER
// xlsx (bower component)
// module id = 487
// module chunks = 0